export interface Character {
  id: string;
  name: string;
  workId: string;
  workTitle: string;
  image: string;
  description: string;
  quote: string;
  plotSummary: string;
}

export const characters: Character[] = [
  {
    id: "maki",
    name: "真纪",
    workId: "harbor-letters",
    workTitle: "海边的信",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20young%20woman%20standing%20by%20the%20seaside%20holding%20an%20old%20letter%2C%20wind%20in%20her%20hair%2C%20muted%20deep%20blue%20and%20warm%20amber%20tones%2C%20soft%20film%20grain%2C%20editorial%20photography&width=800&height=1000&seq=char-maki&orientation=portrait",
    description:
      "海边小镇长大的少女，性格安静而执拗。她习惯把情绪藏在日记里，却因为一封寄错的信，不得不直面自己一直回避的家庭伤口。真纪的成长不是突然的顿悟，而是一点一点学会把心里的话说出口。",
    quote: "有些话，写下来才有勇气说出口。",
    plotSummary:
      "影片中段，真纪独自坐在防波堤上反复读那封信，潮水涨落之间，她第一次对母亲说出了埋藏多年的一句“对不起”。这场没有配乐的戏，是全片情感最浓的转折点。",
  },
  {
    id: "shota",
    name: "翔太",
    workId: "harbor-letters",
    workTitle: "海边的信",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20young%20fisherman%20standing%20on%20a%20small%20boat%20at%20dusk%2C%20warm%20amber%20light%20and%20deep%20blue%20sea%2C%20soft%20film%20grain%2C%20understated%20drama%20photography&width=800&height=1000&seq=char-shota&orientation=portrait",
    description:
      "镇上年轻的渔民之子，与真纪从小一起长大。他不善言辞，却总在真纪最需要的时候出现。翔太代表着那种沉默但可靠的陪伴，也是真纪重新信任他人的起点。",
    quote: "船一靠岸，我就回来了，别怕。",
    plotSummary:
      "结尾处翔太把渔船泊在灯塔下，等待真纪跑来的那一幕，被许多影迷评价为全片最温柔的定格。",
  },
  {
    id: "risa",
    name: "理纱",
    workId: "winter-echo",
    workTitle: "冬日回声",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20woman%20in%20a%20cozy%20record%20store%20surrounded%20by%20vinyl%20records%2C%20warm%20lamp%20light%20and%20cold%20blue%20window%2C%20winter%20atmosphere%2C%20editorial%20photography&width=800&height=1000&seq=char-risa&orientation=portrait",
    description:
      "旧唱片店的店主，独居多年，靠黑胶与热咖啡过冬。她看似平静，心里却始终有一通无法解释的深夜来电。理纱的克制与脆弱，构成了整部剧最动人的张力。",
    quote: "有些回声，要等雪停了才听得清。",
    plotSummary:
      "第九集里理纱终于接起那通电话，却在沉默中听出对方呼吸的节奏——那一刻她意识到，自己等待的答案可能从来不在电话那头。",
  },
  {
    id: "saori",
    name: "纱织",
    workId: "kyoto-summer",
    workTitle: "京都之夏",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20young%20woman%20in%20a%20light%20yukata%20walking%20through%20a%20Kyoto%20alley%20at%20summer%20dusk%2C%20lantern%20light%2C%20warm%20amber%20and%20soft%20green%20tones%2C%20art%20house%20film%20photography&width=800&height=1000&seq=char-saori&orientation=portrait",
    description:
      "独自来京都实习的大学生，带着对未来的迷茫与倔强。她外表活泼，内心却害怕做选择。一个夏天的人和事，让她学会承认自己真正想要的东西。",
    quote: "夏天会结束，但我是为了留下来才来的。",
    plotSummary:
      "祭典之夜，纱织在人群中第一次主动牵起对方的手，烟花升起的一刻，她终于说出了那句一直没敢说的话。",
  },
  {
    id: "kotone",
    name: "琴音",
    workId: "silent-confession",
    workTitle: "无声告白",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20focused%20young%20woman%20sign%20language%20interpreter%20in%20a%20quiet%20interview%20room%2C%20cool%20navy%20tones%20with%20a%20single%20warm%20lamp%2C%20moody%20thriller%20photography&width=800&height=1000&seq=char-kotone&orientation=portrait",
    description:
      "职业手语翻译，敏锐且极具观察力。她相信每一句被翻译的话都值得被认真对待，也因此成为案件中唯一察觉异常的人。琴音的冷静之下，藏着对真相近乎固执的执着。",
    quote: "手会说出嘴不想说的话。",
    plotSummary:
      "审讯室的对手戏中，琴音在翻译的间隙停顿了半秒——正是这半秒，让观众意识到她读懂了对方隐藏的恐惧。",
  },
  {
    id: "yuki",
    name: "由纪",
    workId: "seventh-night",
    workTitle: "第七个夜晚",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20mysterious%20young%20woman%20standing%20by%20a%20gas%20station%20at%20night%2C%20deep%20navy%20darkness%20and%20amber%20sign%20light%2C%20suspense%20drama%20photography&width=800&height=1000&seq=char-yuki&orientation=portrait",
    description:
      "连续七夜出现在公路加油站的沉默女顾客。她话不多，眼神里却装着一段无人知晓的旅程。由纪是整部电影最大的谜题，也是解开所有线索的钥匙。",
    quote: "我只是想确认，这条路还通不通。",
    plotSummary:
      "第七夜她放下信封后驾车消失在夜色里，加油站少年打开信封，发现里面全是同一个人的照片——故事由此逆向展开。",
  },
  {
    id: "aoi",
    name: "葵",
    workId: "falling-sakura",
    workTitle: "樱花落尽",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20high%20school%20girl%20in%20uniform%20standing%20in%20a%20corridor%20with%20falling%20cherry%20blossoms%2C%20soft%20pink%20and%20pale%20blue%20tones%2C%20nostalgic%20film%20photography&width=800&height=1000&seq=char-aoi&orientation=portrait",
    description:
      "即将毕业的高三学生，外表洒脱，其实最怕分别。她把所有不舍都写进了那封给十年后自己的信里，却始终没敢交给对方。",
    quote: "十年以后，你还会记得今天的花吗？",
    plotSummary:
      "短片结尾，葵把信折好放进树洞，镜头拉远，樱花落在空无一人的走廊上——青春就此落幕。",
  },
  {
    id: "rin",
    name: "凛",
    workId: "city-lights",
    workTitle: "城市之光",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20young%20female%20radio%20host%20in%20a%20dim%20studio%20with%20headphones%2C%20deep%20blue%20room%20and%20warm%20orange%20on%20air%20light%2C%20urban%20night%20drama%20photography&width=800&height=1000&seq=char-rin&orientation=portrait",
    description:
      "深夜电台主播，声音温柔而治愈。她习惯于接住别人的情绪，却很少允许自己被接住。整部剧跟着她一起，走进都市人各自的孤独与微光。",
    quote: "今夜的城市很亮，你并不孤单。",
    plotSummary:
      "最后一集，凛第一次在节目里讲起自己，直播间外的城市灯火与听众发来的短信一同亮起，成为她重新出发的底气。",
  },
  {
    id: "himawari",
    name: "向日葵",
    workId: "chasing-wind",
    workTitle: "追风的少女",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20determined%20young%20woman%20on%20a%20bicycle%20along%20a%20coastal%20road%20at%20golden%20hour%2C%20warm%20amber%20light%20and%20teal%20sea%2C%20coming%20of%20age%20film%20photography&width=800&height=1000&seq=char-himawari&orientation=portrait",
    description:
      "身患心脏疾病却执意远行的少女。她灿烂、任性、害怕来不及，所以把每一天都过得像最后一天。向日葵是那种会让你想起“活着”本身的角色。",
    quote: "风不停，我就不停。",
    plotSummary:
      "骑到终点灯塔的那个清晨，向日葵摘下头盔大口喘气，笑着哭出来——她终于证明自己可以决定人生的节奏。",
  },
  {
    id: "nagi",
    name: "凪",
    workId: "rainy-season",
    workTitle: "雨季不再来",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20quiet%20young%20woman%20sitting%20in%20a%20laundromat%20by%20a%20rainy%20window%2C%20soft%20blue%20light%20and%20warm%20lamp%2C%20melancholic%20minimal%20film%20photography&width=800&height=1000&seq=char-nagi&orientation=portrait",
    description:
      "在雨季里与自己相处的人。她没有太多台词，却用整个短片的状态，讲述了一个人如何学会安静地面对遗憾。凪是克制表演的代表。",
    quote: "雨停了，我就把信寄出去。",
    plotSummary:
      "全片最后，凪把没寄出的信折成纸船放进积水里，目送它漂远——没有眼泪，却让人久久说不出话。",
  },
  {
    id: "chiyo",
    name: "千代",
    workId: "snow-country",
    workTitle: "雪国来信",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20woman%20in%20a%20red%20scarf%20standing%20on%20a%20snowy%20train%20platform%2C%20cold%20blue%20tones%20with%20warm%20red%20accent%2C%20literary%20period%20drama%20photography&width=800&height=1000&seq=char-chiyo&orientation=portrait",
    description:
      "穿越雪国寻找丈夫的女子，坚忍而深情。她相信信里提到的车站一定存在，就像她相信等待本身有意义。千代承载着那个年代女性的隐忍与力量。",
    quote: "只要还有一站没到，我就还要往前。",
    plotSummary:
      "当火车驶过那片空白的雪原，千代终于明白车站不在铁轨上，而在她愿意继续前行的心里。",
  },
  {
    id: "haruka",
    name: "遥",
    workId: "starlight-promise",
    workTitle: "星光下的约定",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20young%20woman%20stargazing%20through%20a%20telescope%20on%20a%20hilltop%20at%20night%2C%20deep%20navy%20sky%20with%20warm%20star%20light%2C%20romantic%20drama%20photography&width=800&height=1000&seq=char-haruka&orientation=portrait",
    description:
      "天文台实习生，理性、安静，习惯用星空丈量时间。她把约定看作轨道上的两颗行星，明知会渐行渐远，仍愿意等待一次重逢。",
    quote: "星星很慢，但它们从不错过重逢。",
    plotSummary:
      "流星季的夜晚，遥在望远镜里看见对方一步步走上山来，她没有回头，只是轻声说了一句“你迟到了”。",
  },
  {
    id: "misaki",
    name: "美咲",
    workId: "tender-lies",
    workTitle: "温柔的谎言",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20an%20elegant%20young%20woman%20standing%20in%20a%20warm%20apartment%20interior%20looking%20at%20her%20reflection%2C%20amber%20and%20deep%20teal%20tones%2C%20family%20drama%20photography&width=800&height=1000&seq=char-misaki&orientation=portrait",
    description:
      "夹在母亲与祖母之间的女儿，努力维持着家庭的体面。她最擅长说善意的谎言，也最先被谎言灼伤。美咲的挣扎，是许多家庭的缩影。",
    quote: "我说谎，是因为我怕你们失望。",
    plotSummary:
      "家庭聚餐的那场戏，美咲在所有人面前第一次说出真相，餐桌骤然安静——温柔的谎言终于走到了尽头。",
  },
];

export function getCharacterById(id: string): Character | undefined {
  return characters.find((c) => c.id === id);
}